<template>
    <div></div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>